export default function bar () {
	console.log( 'hello from bar.js' );
}
